import { QuestionStatus } from '@exam-management/graphql';
import { type LabelProps, Label } from '@shared/components';

import { QCONTENT_COLOR_STATUS, QCONTENT_STATUS_TEXT } from './constants';

export interface QContentStatusTagProps extends LabelProps {
  status: QuestionStatus;
}

export default function QContentStatusTag(props: Readonly<QContentStatusTagProps>) {
  const { status, ...restProps } = props;

  const isPreDraftColor = [
    QuestionStatus.InDevelopment,
    QuestionStatus.InReview,
    QuestionStatus.PreDraft,
  ].includes(status);

  return (
    <Label
      color={QCONTENT_COLOR_STATUS[status]}
      variant='outlined'
      sx={(theme) => {
        if (isPreDraftColor) {
          return {
            color: theme.palette.info.main,
            borderColor: theme.palette.info.light,
            backgroundColor: theme.palette.info.lighter,
          };
        }
        return {};
      }}
      {...restProps}
    >
      {QCONTENT_STATUS_TEXT[status]}
    </Label>
  );
}
